"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var __1 = require("../");
var utils_1 = require("../../utils/");
var Model_1 = require("../Model");
var Image_1 = require("./Image");
var checkIfExists = utils_1.checkIfPropertyExtists("Driver");
var Driver = /** @class */ (function (_super) {
    __extends(Driver, _super);
    function Driver(id, name, emailAddress, phoneNumber, picture, subcoId, active, invoiceSubcontractorId, isPlanner, isArchived) {
        var _this = _super.call(this, id) || this;
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Driver.makeRequest("/delivery/functions/create-driver/", Model_1.METHOD.POST, {
                            emailAddress: this.getEmailAddress,
                            name: this.getName,
                            phoneNumber: this.getPhoneNumber,
                            picture: this.getPicture,
                            subcontractorId: this.getSubcoId,
                            invoiceSubcontractorId: this.invoiceSubcontractorId,
                            isPlanner: this.isPlanner,
                        })];
                    case 1:
                        result = _a.sent();
                        this.setId = lodash_1.get(result, 'id');
                        this.setUserSub = lodash_1.get(result, 'userSub');
                        return [2 /*return*/, this];
                }
            });
        }); };
        _this.addLedgerEntry = function (stateName, latitude, longitude) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = checkIfExists({ key: 'ID', value: this.getId });
                        return [4 /*yield*/, Driver.makeRequest("/delivery/functions/driver/add-state/" + id, Model_1.METHOD.POST, {
                                latitude: latitude,
                                longitude: longitude,
                                stateName: stateName,
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        }); };
        _this.activate = function (latitude, longitude) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = checkIfExists({ key: 'ID', value: this.getId });
                        return [4 /*yield*/, Driver.makeRequest("/delivery/functions/driver/set-to-active/" + id, Model_1.METHOD.POST, {
                                latitude: latitude,
                                longitude: longitude,
                            })];
                    case 1:
                        _a.sent();
                        this.setActive = true;
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        }); };
        _this.deactivate = function (latitude, longitude) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = checkIfExists({ key: 'ID', value: this.getId });
                        return [4 /*yield*/, Driver.makeRequest("/delivery/functions/driver/set-to-inactive/" + id, Model_1.METHOD.POST, {
                                latitude: latitude,
                                longitude: longitude,
                            })];
                    case 1:
                        _a.sent();
                        this.setActive = false;
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        }); };
        _this.assign = function () { return _this.addLedgerEntry("DRIVER_ASSIGNED"); };
        _this.deassign = function () { return _this.addLedgerEntry("DRIVER_ACTIVE"); };
        _this.drive = function (latitude, longitude) {
            return _this.addLedgerEntry("DRIVER_DRIVING", latitude, longitude);
        };
        _this.finish = function (latitude, longitude) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Driver.makeRequest("/delivery/functions/driver-finished/" + this.getId, Model_1.METHOD.POST, {
                            latitude: latitude,
                            longitude: longitude,
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        }); };
        _this.noNeighbourCard = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Driver.makeRequest("/delivery/functions/no-neighbour-card/" + this.getId, Model_1.METHOD.GET)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.fetchAssignedTourByDate = function (date) { return __awaiter(_this, void 0, void 0, function () {
            var id, tours, _a, _i, tours_1, tour, active;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = checkIfExists({ key: 'ID', value: this.getId });
                        _a = lodash_1.orderBy;
                        return [4 /*yield*/, __1.Tour.fetchByDateAndDriverId(date, id)];
                    case 1:
                        tours = _a.apply(void 0, [_b.sent(),
                            'id',
                            'desc']);
                        _i = 0, tours_1 = tours;
                        _b.label = 2;
                    case 2:
                        if (!(_i < tours_1.length)) return [3 /*break*/, 5];
                        tour = tours_1[_i];
                        return [4 /*yield*/, tour.isActive()];
                    case 3:
                        active = _b.sent();
                        if (active) {
                            return [2 /*return*/, tour];
                        }
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.createDriverLocationData = function (params) {
            return Driver.makeRequest("/spatial/functions/driver-location-data/" + _this.getId, Model_1.METHOD.POST, params);
        };
        _this.fetchUser = function () {
            return _this.fetchNestedModel('setUser', __1.User.fetchByDriverId, 'getId');
        };
        _this.fetchSubco = function () {
            return _this.fetchNestedModel('setSubco', __1.Subco.fetch, 'getSubcoId');
        };
        _this.fetchLedger = function () {
            return _this.fetchNestedModel('setLedger', __1.DriverLedger.fetchByDriverId, 'getId');
        };
        _this.setName = name;
        _this.setEmailAddress = emailAddress;
        _this.setPhoneNumber = phoneNumber;
        _this.setActive = active;
        _this.setSubcoId = subcoId;
        _this.invoiceSubcontractorId = invoiceSubcontractorId;
        _this.isPlanner = isPlanner;
        _this.isArchived = isArchived;
        if (picture) {
            Image_1.Image.fetch(picture)
                .then(function (image) { return (_this.setPicture = image); })
                .catch(utils_1.logger.error);
        }
        return _this;
    }
    /**
     * Fetches driver tracking consent, returns sign url if not yet signed
     * @param driverId
     * @returns Promise<IGetDriverTrackingConsentResponse>
     */
    Driver.getDriverTrackingConsent = function (driverId) {
        return Driver.makeRequest("/delivery/functions/get-driver-tracking-consent/" + driverId, Model_1.METHOD.GET);
    };
    /**
     * Creates driver tracking consent
     * @param IAddDriverTrackingConsentParams
     * @returns Promise<IAddDriverTrackingConsentResponse>
     */
    Driver.addDriverTrackingConsent = function (_a) {
        var driverId = _a.driverId, referenceId = _a.referenceId, deviceId = _a.deviceId, versionId = _a.versionId;
        return Driver.makeRequest('/delivery/functions/add-driver-tracking-consent', Model_1.METHOD.POST, { driverId: driverId, referenceId: referenceId, deviceId: deviceId, versionId: versionId });
    };
    /**
     * Temporarily switches the driver to a different subcontractor.
     * Automatically resets every morning at 0400 GMT+0
     * @param driverId
     * @param temporarySubcontractorId
     */
    Driver.temporarilySwitchSubcontractor = function (driverId, temporarySubcontractorId) {
        return Driver.makeRequest("/delivery/driver-switch", Model_1.METHOD.PUT, {
            driverId: driverId,
            temporarySubcontractorId: temporarySubcontractorId,
        });
    };
    /**
     * If a driver has been temp. switched to a different subco.
     * This method undoes that.
     * @param driverId
     */
    Driver.undoTemporarySubcontractorSwitch = function (driverId) {
        return Driver.makeRequest("/delivery/undo-driver-switch", Model_1.METHOD.PUT, {
            driverId: driverId,
        });
    };
    Driver.listTemporaryDriverSwitches = function () {
        return Driver.makeRequest('delivery/driver-switch', Model_1.METHOD.GET);
    };
    Object.defineProperty(Driver.prototype, "getName", {
        /**
         * GETTERS
         */
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getEmailAddress", {
        get: function () {
            return this.emailAddress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getPhoneNumber", {
        get: function () {
            return this.phoneNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getPicture", {
        get: function () {
            return this.picture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getActive", {
        get: function () {
            return this.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getUser", {
        get: function () {
            return this.checkIfPropertyIsFetched('user', this.fetchUser);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getSubcoId", {
        get: function () {
            return this.subcoId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getSubco", {
        get: function () {
            return this.checkIfPropertyIsFetched('subco', this.fetchSubco);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getLedger", {
        get: function () {
            return this.checkIfPropertyIsFetched('ledger', this.fetchLedger);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getInvoiceSubcontractorId", {
        get: function () {
            return this.invoiceSubcontractorId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "getUserSub", {
        get: function () {
            return this.userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setName", {
        /**
         * SETTERS
         */
        set: function (name) {
            this.name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setEmailAddress", {
        set: function (emailAddress) {
            this.emailAddress = emailAddress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setPhoneNumber", {
        set: function (phoneNumber) {
            this.phoneNumber = phoneNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setPicture", {
        set: function (picture) {
            this.picture = picture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setActive", {
        set: function (active) {
            this.active = active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setUser", {
        set: function (user) {
            this.user = user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setSubcoId", {
        set: function (subcoId) {
            this.subcoId = subcoId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setSubco", {
        set: function (subco) {
            this.subco = subco;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setLedger", {
        set: function (ledger) {
            this.ledger = ledger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setInvoiceSubcontractorId", {
        set: function (subcoId) {
            this.invoiceSubcontractorId = subcoId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Driver.prototype, "setUserSub", {
        set: function (userSub) {
            this.userSub = userSub;
        },
        enumerable: true,
        configurable: true
    });
    Driver.fetch = function (driverId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Driver.makeRequest("/delivery/functions/fetch-driver-info/" + driverId, Model_1.METHOD.GET)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, new Driver(result.id, result.name, result.emailAddress, result.phoneNumber, result.picture, result.subcontractorId, result.active, lodash_1.get(result, 'invoiceSubcontractorId'), result.isPlanner, lodash_1.get(result, 'isArchived'))];
            }
        });
    }); };
    Driver.fetchAll = function () { return Driver.makeRequest('/delivery/functions/driver/', Model_1.METHOD.GET); };
    Driver.fetchAllDrivers = function () { return Driver.makeRequest('/delivery/private/driver/', Model_1.METHOD.GET, {
        filter: {
            select: ['userSub', 'name'],
        },
    }); };
    /**
     *
     * @param driverId
     * @returns statusCodes 204, 404, 422, 500
     */
    Driver.editDriverInfo = function (driverId, payload) {
        return Driver.makeRequest("/delivery/functions/edit-driver/" + driverId, Model_1.METHOD.PUT, payload);
    };
    Driver.fetchDeliveries = function (driverId) {
        return Driver.makeRequest("/delivery/functions/driver-deliveries/" + driverId, Model_1.METHOD.GET);
    };
    Driver.transferDriver = function (driverId, subcontractorId) {
        return Driver.makeRequest('/delivery/functions/transfer-driver-to-sub-co', Model_1.METHOD.PUT, {
            driverId: driverId,
            subcontractorId: subcontractorId,
        });
    };
    Driver.requestCallback = function (driverId) { return Driver.makeRequest('/delivery/functions/request-driver-callback', Model_1.METHOD.POST, { driverId: driverId }); };
    Driver.receiveCallback = function (callbackRequestId, receivedAt) { return Driver.makeRequest('/delivery/functions/receive-driver-callback', Model_1.METHOD.PUT, {
        callbackRequestId: callbackRequestId,
        receivedAt: receivedAt,
    }); };
    Driver.respondToCallback = function (callbackRequestId, respondedAt) { return Driver.makeRequest('/delivery/functions/respond-to-driver-callback', Model_1.METHOD.PUT, {
        callbackRequestId: callbackRequestId,
        respondedAt: respondedAt,
    }); };
    Driver.setUserPreferencesById = function (driverId, key, value) { return Driver.makeRequest("/delivery/functions/set-driver-preferences/" + driverId, Model_1.METHOD.PUT, {
        key: key,
        value: value,
    }); };
    Driver.createDriver = function (payload) { return Driver.makeRequest("/delivery/functions/create-driver/", Model_1.METHOD.POST, payload); };
    Driver.moveDriver = function (payload) { return Driver.makeRequest("/delivery/functions/transfer-driver", Model_1.METHOD.PUT, payload); };
    Driver.findDriverByPhone = function (phoneNumber) { return Driver.makeRequest("/delivery/functions/find-driver-by-phone-number/" + phoneNumber, Model_1.METHOD.GET); };
    return Driver;
}(Model_1.Model));
exports.Driver = Driver;
